import React, { useEffect } from "react";
import Slider from "react-slick";
import Button from "@mui/material/Button";
import { TextField } from "@mui/material";
import { useForm } from "react-hook-form";
import { useRequest } from "../../hooks/useRequest/useRequest";
import { useParams } from "react-router-dom";
import { REQUEST_STATUS } from "../../hooks/useRequest/useRequest.constants";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "./fetchProduct.css";
import { IMG_URL } from "../../api/imgApi/ImgApi";
import PhoneInput from "../../components/PhoneInput/PhoneInput";

const FetchProduct = () => {
  const { productId } = useParams();

  const lang: any = localStorage.getItem("i18nextLng");

  const { t } = useTranslation();

  const [fectProductClient, fetchProductData, fetchProductStatus] =
    useRequest();

  const [appealProductClient, appealProductData, appealProductStatus] =
    useRequest();

  const settings: any = {
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    customPaging: function (i: number) {
      return (
        <a>
          <LazyLoadImage
            alt="product"
            effect="blur"
            src={IMG_URL + `${fetchProductData?.data?.image?.[i]?.url}`}
          />
        </a>
      );
    },
  };

  const {
    reset,
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = (data: any) => {
    let newData = {
      name: data.name,
      phoneNumber: data.phoneNumber,
      productId: productId,
      quantity: +data.quantity,
      amountType: data.amountType === "dona" ? "piece" : "pack",
      type: "order",
      comment: data.comment,
    };
    appealProductClient.post("appeal", newData);
  };

  useEffect(() => {
    fectProductClient.get(`product/${productId}`);
  }, [productId]);

  useEffect(() => {
    if (appealProductStatus === REQUEST_STATUS.success) {
      toast.success("Ariza muvoffaqqiyatli yuborildi");
      reset();
      setValue("phoneNumber", "");
    }
  }, [appealProductStatus]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="fetch_pt_container">
        <div className="fetch_pt_slidee">
          <Slider {...settings} className="my_slide_pt">
            {fetchProductData?.data?.image?.map((item: any, index: any) => (
              <div className="slide_box" key={index}>
                <LazyLoadImage
                  alt="product"
                  effect="blur"
                  src={IMG_URL + item.url}
                />
              </div>
            ))}
          </Slider>
        </div>
        <div className="fetch_pt_form">
          <header>
            <h3 className={lang === "ru" ? "active" : ""}>
              {t("FETCHONEPRODUCT.TITLE")}
            </h3>
          </header>
          <form className="form_buyurtma" onSubmit={handleSubmit(onSubmit)}>
            <div className="box two-input">
              <p className="name_input">
                <label>{t("FETCHONEPRODUCT.NAME")}</label>
                <input
                  type="text"
                  {...register("name", {
                    required: true,
                  })}
                  placeholder="Ismingizni kiriting"
                  className="ft_input"
                />
                {errors.name && (
                  <span className="error_input">
                    {t("FETCHONEPRODUCT.ERRORTEXT")}
                  </span>
                )}
              </p>
              <p className="phone_input">
                <label className="phone_title">
                  {t("FETCHONEPRODUCT.PHONE_NUMBER")}
                </label>
                <PhoneInput
                  placeholder="Telefon raqam"
                  className="appeal_phone_input"
                  params={{
                    ...register("phoneNumber", {
                      required: true,
                    }),
                  }}
                />
                {errors.phoneNumber && (
                  <span className="error_input">
                    {t("FETCHONEPRODUCT.ERRORTEXT")}
                  </span>
                )}
              </p>
            </div>

            <div className="box text_are">
              <p className="text_input">
                <label>{t("FETCHONEPRODUCT.COMMENT")}</label>
                <textarea
                  placeholder="Yozing"
                  {...register("comment", {
                    required: true,
                  })}
                ></textarea>
                {errors.comment && (
                  <span className="error_input">
                    {t("FETCHONEPRODUCT.ERRORTEXT")}
                  </span>
                )}
              </p>
            </div>

            <div className="box two-input">
              <p className="miqdor_input name_input">
                <label>{t("FETCHONEPRODUCT.AMOUNT")}</label>
                <input
                  {...register("quantity", {
                    required: true,
                  })}
                  placeholder="0"
                  type="number"
                  className="ft_input"
                />
                {errors.quantity && (
                  <span className="error_input">
                    {t("FETCHONEPRODUCT.ERRORTEXT")}
                  </span>
                )}
              </p>
              <p className="select_miqdor">
                <label htmlFor="selectCategory">
                  {t("FETCHONEPRODUCT.AMOUNTTYPE")}
                </label>
                <select
                  {...register("amountType", {
                    required: true,
                  })}
                >
                  <option value="dona">{t("FETCHONEPRODUCT.PIECE")}</option>
                  <option value="pachka">{t("FETCHONEPRODUCT.PACK")}</option>
                </select>
                {errors.amountType && (
                  <span className="error_input">
                    {t("FETCHONEPRODUCT.ERRORTEXT")}
                  </span>
                )}
              </p>
            </div>

            <div className="box submit-button-box">
              <Button type="submit" className="submit_btn">
                {t("FETCHONEPRODUCT.SENDBTN")}
              </Button>
              <p></p>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default FetchProduct;
